import React, { useContext, useState } from 'react';
import { PostContext } from '../../../context/DataContext';
import UsePost from '../../../components/hook/UsePost';
import Header from '../../../components/navegation/header/Header';
import Main from '../../../components/interface/main/Main';
import Footer from '../../../components/navegation/footer/Footer';
import FellowshipProgramHeader from './FellowshipProgramHeader';
import FellowshipProgramContent from './FellowshipProgramContent';
import OrganizersElement from '../../../components/design/organizers/OrganizersElement';
import UseTimeOut from '../../../components/hook/UseTimeOut';
import UseLangLocation from '../../../components/hook/UseLangLocation';
import SponsorsSlider from '../../../components/sections/sponsors/SponsorsSlider';
import StickyHeader from '../../../components/interface/sticky-header /StickyHeader';



const FellowshipProgramBody = props => {
    const { page_number } = props;
    const { content, handleApiURL, handleID, title, handleLoading, status, accordion, button } = useContext(PostContext)
    const [loading, setLoading] = useState(true);


    return (
        <UseLangLocation>
            <UsePost enabled handleApiURL={handleApiURL} url='https://apievt.lacnic.net/wp-json/wp/v2/participate' handleLoading={handleLoading} handleID={handleID} id='718' >
                <Header title={title} loading={loading} {...props} />
                <Main className='container fellowship_program' status={status} loading={loading}>
                    <section>
                        <UseTimeOut timeout='700' loading={loading} setLoading={setLoading} title={title}> 
                            <SponsorsSlider/>
                            <StickyHeader/>
                            <FellowshipProgramHeader content={content} title={title} button={button} />
                            <FellowshipProgramContent accordion={accordion} page_number={page_number} />
                        </UseTimeOut>
                    </section>
                </Main>
                <OrganizersElement />
                <Footer className="master_foot foot_home" />
            </UsePost>
        </UseLangLocation>
    )
}

export default FellowshipProgramBody

